import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":("//" + _vm.value),"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c(VIcon,{staticClass:"mx-2",attrs:{"small":""}},[_vm._v("arrow_outward")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }